import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { carImagesUrl, getRequest, errorNotification } from '../../config'
import LightBox from '../../components/LightBox'

const CarImageViewer = ({ carId, visible, onClose }) => {
  const [images, setImages] = useState([])
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)
  // We need this state to control the LightBox visibility independently if needed,
  // but for now we can sync it with the 'visible' prop effectively or just pass it through.
  // However, LightBox component takes openSlideShow and setOpenSlideShow.
  // We can just use the 'visible' prop to conditionally render or control the LightBox.
  // Let's check LightBox implementation again. It takes openSlideShow and setOpenSlideShow.
  // setOpenSlideShow(false) is called on close. So we should pass a handler that calls onClose.

  const getCarImages = async () => {
    if (!carId) return

    // Reset images only if it's a new request to avoid flashing empty if re-opening same car (optional optimization, but good to keep it simple first)
    // Actually, usually we want fresh data or we cache it. For now, simple fetch on every open is safer.
    setImages([])

    const response = await getRequest(
      `${carImagesUrl}/for-car/?car=${carId}`,
      'car images',
      setLoading
    )
    if (response.success) {
      setImages(response.data)
    } else {
      if (response.error.response) {
        errorNotification(response.error.response.data.message)
      }
    }
  }

  useEffect(() => {
    if (visible && carId) {
      getCarImages()
    }
    // eslint-disable-next-line
  }, [visible, carId])

  // If not visible, we don't strictly need to render the LightBox if it has an 'open' prop,
  // but conditionally rendering it ensures it re-mounts/resets if needed.
  // However, LightBox likely handles 'open' state itself.
  // Let's pass the images and handle the close.

  if (!visible) return null

  return (
    <LightBox
      images={images.map(img => img.image)}
      openSlideShow={visible}
      setOpenSlideShow={isOpen => {
        if (!isOpen) onClose()
      }}
    />
  )
}

CarImageViewer.propTypes = {
  carId: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default CarImageViewer
